export default __webpack_public_path__ + "static/ay-support-content-security-40b27cfad15e363439f5117ce4f11c43.svg";